import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {
  Box,
  Stack,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { marketplaceTypography as mt } from "../constants/marketplaceTypography";

const AUTO_CLOSE_DELAY_MS = 2500;

/** Página pública — exibida no popup após vinculação SSO com dispensador WooCommerce. */
export function DispensaryAccountLinkSuccessPage() {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const dispensaryName = searchParams.get("dispensador")?.trim();

  useEffect(() => {
    const timer = window.setTimeout(() => {
      try {
        window.close();
      } catch {
        // browsers podem bloquear close em abas não abertas via script
      }
    }, AUTO_CLOSE_DELAY_MS);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: alpha(theme.palette.primary800.main, 0.04),
        px: 2,
        py: 4,
      }}
    >
      <Stack
        spacing={2}
        alignItems="center"
        sx={{
          maxWidth: 420,
          width: "100%",
          p: { xs: 3, sm: 4 },
          borderRadius: 2,
          bgcolor: "background.paper",
          border: `1px solid ${alpha(theme.palette.primary800.main, 0.14)}`,
          boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.08)}`,
          textAlign: "center",
        }}
      >
        <CheckCircleOutlineIcon
          sx={{ fontSize: 56, color: "success.main" }}
          aria-hidden
        />
        <Typography sx={{ ...mt.pageTitle, color: "primary800.main" }}>
          Conta vinculada com sucesso
        </Typography>
        <Typography sx={{ ...mt.body, color: "text.secondary" }}>
          {dispensaryName ? (
            <>
              Sua conta Fluxmed foi associada ao dispensador{" "}
              <strong>{dispensaryName}</strong>.
            </>
          ) : (
            <>Sua conta Fluxmed foi associada ao dispensador parceiro.</>
          )}
        </Typography>
        <Typography sx={{ ...mt.bodySecondary, color: "text.secondary" }}>
          Por favor, <strong>feche esta janela</strong> e volte ao Fluxmed para
          continuar sua solicitação.
        </Typography>
      </Stack>
    </Box>
  );
}
